/** Alfabeto sem caracteres ambíguos (0/O, 1/I) para o código ditado por telefone. */
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

/**
 * Gera um código de cupom de 5 caracteres. A unicidade por evento é validada
 * no backend (o front só sugere) — tratar o erro CODIGO_JA_EM_USO.
 */
export const generateCouponCode = (length = 5): string => {
  let code = ''
  for (let i = 0; i < length; i += 1) {
    code += ALPHABET[Math.floor(Math.random() * ALPHABET.length)]
  }
  return code
}

/** Link de compra do cupom — usa o ID do comissário, não o código. */
export const buildCouponLink = (slug: string, comissarioId: number): string =>
  `https://www.bilheteriadigital.com/${slug}?c=${comissarioId}`

/** `2026-02-14T23:59:00` (banco) -> `2026-02-14T23:59` (input datetime-local). */
export const toDateTimeLocal = (value: string | null): string => {
  if (!value) return ''
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/)
  return match ? `${match[1]}T${match[2]}` : ''
}
